/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Status, statusFromJSON, statusToJSON } from "./constants";
import {
  WifiConnectedState,
  WifiConnectFailedReason,
  wifiConnectFailedReasonFromJSON,
  wifiConnectFailedReasonToJSON,
  WifiStationState,
  wifiStationStateFromJSON,
  wifiStationStateToJSON,
} from "./wifi_constants";

export const protobufPackage = "espressif";


export enum WiFiConfigMsgType {
  TypeCmdGetStatus = 0,
  TypeRespGetStatus = 1,
  TypeCmdSetConfig = 2,
  TypeRespSetConfig = 3,
  TypeCmdApplyConfig = 4,
  TypeRespApplyConfig = 5,
  UNRECOGNIZED = -1
}

export function wiFiConfigMsgTypeFromJSON(object: any): WiFiConfigMsgType {
  switch (object) {
    case 0:
    case "TypeCmdGetStatus":
      return WiFiConfigMsgType.TypeCmdGetStatus;
    case 1:
    case "TypeRespGetStatus":
      return WiFiConfigMsgType.TypeRespGetStatus;
    case 2:
    case "TypeCmdSetConfig":
      return WiFiConfigMsgType.TypeCmdSetConfig;
    case 3:
    case "TypeRespSetConfig":
      return WiFiConfigMsgType.TypeRespSetConfig;
    case 4:
    case "TypeCmdApplyConfig":
      return WiFiConfigMsgType.TypeCmdApplyConfig;
    case 5:
    case "TypeRespApplyConfig":
      return WiFiConfigMsgType.TypeRespApplyConfig;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WiFiConfigMsgType.UNRECOGNIZED;
  }
}

export function wiFiConfigMsgTypeToJSON(object: WiFiConfigMsgType): string {
  switch (object) {
    case WiFiConfigMsgType.TypeCmdGetStatus:
      return "TypeCmdGetStatus";
    case WiFiConfigMsgType.TypeRespGetStatus:
      return "TypeRespGetStatus";
    case WiFiConfigMsgType.TypeCmdSetConfig:
      return "TypeCmdSetConfig";
    case WiFiConfigMsgType.TypeRespSetConfig:
      return "TypeRespSetConfig";
    case WiFiConfigMsgType.TypeCmdApplyConfig:
      return "TypeCmdApplyConfig";
    case WiFiConfigMsgType.TypeRespApplyConfig:
      return "TypeRespApplyConfig";
    case WiFiConfigMsgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CmdGetStatus {
}

export interface RespGetStatus {
  status: Status;
  staState: WifiStationState;
  failReason?: WifiConnectFailedReason | undefined;
  connected?: WifiConnectedState | undefined;
}

export interface CmdSetConfig {
  ssid: Uint8Array;
  passphrase: Uint8Array;
  bssid: Uint8Array;
  channel: number;
}

export interface RespSetConfig {
  status: Status;
}

export interface CmdApplyConfig {
}

export interface RespApplyConfig {
  status: Status;
}

export interface WiFiConfigPayload {
  msg: WiFiConfigMsgType;
  cmdGetStatus?: CmdGetStatus | undefined;
  respGetStatus?: RespGetStatus | undefined;
  cmdSetConfig?: CmdSetConfig | undefined;
  respSetConfig?: RespSetConfig | undefined;
  cmdApplyConfig?: CmdApplyConfig | undefined;
  respApplyConfig?: RespApplyConfig | undefined;
}

function createBaseCmdGetStatus(): CmdGetStatus {
  return {};
}

export const CmdGetStatus = {
  encode(_: CmdGetStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdGetStatus {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdGetStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): CmdGetStatus {
    return {};
  },

  toJSON(_: CmdGetStatus): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdGetStatus>, I>>(base?: I): CmdGetStatus {
    return CmdGetStatus.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdGetStatus>, I>>(_: I): CmdGetStatus {
    const message = createBaseCmdGetStatus();
    return message;
  },
};

function createBaseRespGetStatus(): RespGetStatus {
  return { status: 0, staState: 0, failReason: undefined, connected: undefined };
}

export const RespGetStatus = {
  encode(message: RespGetStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.staState !== 0) {
      writer.uint32(16).int32(message.staState);
    }
    if (message.failReason !== undefined) {
      writer.uint32(80).int32(message.failReason);
    }
    if (message.connected !== undefined) {
      WifiConnectedState.encode(message.connected, writer.uint32(90).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespGetStatus {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespGetStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = reader.int32() as any;
          break;
        case 2:
          message.staState = reader.int32() as any;
          break;
        case 10:
          message.failReason = reader.int32() as any;
          break;
        case 11:
          message.connected = WifiConnectedState.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RespGetStatus {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      staState: isSet(object.staState) ? wifiStationStateFromJSON(object.staState) : 0,
      failReason: isSet(object.failReason) ? wifiConnectFailedReasonFromJSON(object.failReason) : undefined,
      connected: isSet(object.connected) ? WifiConnectedState.fromJSON(object.connected) : undefined,
    };
  },

  toJSON(message: RespGetStatus): unknown {
    const obj: any = {};
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    message.staState !== undefined && (obj.staState = wifiStationStateToJSON(message.staState));
    message.failReason !== undefined &&
      (obj.failReason = message.failReason !== undefined
        ? wifiConnectFailedReasonToJSON(message.failReason)
        : undefined);
    message.connected !== undefined &&
      (obj.connected = message.connected ? WifiConnectedState.toJSON(message.connected) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<RespGetStatus>, I>>(base?: I): RespGetStatus {
    return RespGetStatus.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespGetStatus>, I>>(object: I): RespGetStatus {
    const message = createBaseRespGetStatus();
    message.status = object.status ?? 0;
    message.staState = object.staState ?? 0;
    message.failReason = object.failReason ?? undefined;
    message.connected = (object.connected !== undefined && object.connected !== null)
      ? WifiConnectedState.fromPartial(object.connected)
      : undefined;
    return message;
  },
};

function createBaseCmdSetConfig(): CmdSetConfig {
  return { ssid: new Uint8Array(), passphrase: new Uint8Array(), bssid: new Uint8Array(), channel: 0 };
}

export const CmdSetConfig = {
  encode(message: CmdSetConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ssid.length !== 0) {
      writer.uint32(10).bytes(message.ssid);
    }
    if (message.passphrase.length !== 0) {
      writer.uint32(18).bytes(message.passphrase);
    }
    if (message.bssid.length !== 0) {
      writer.uint32(26).bytes(message.bssid);
    }
    if (message.channel !== 0) {
      writer.uint32(32).int32(message.channel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdSetConfig {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdSetConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.ssid = reader.bytes();
          break;
        case 2:
          message.passphrase = reader.bytes();
          break;
        case 3:
          message.bssid = reader.bytes();
          break;
        case 4:
          message.channel = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CmdSetConfig {
    return {
      ssid: isSet(object.ssid) ? bytesFromBase64(object.ssid) : new Uint8Array(),
      passphrase: isSet(object.passphrase) ? bytesFromBase64(object.passphrase) : new Uint8Array(),
      bssid: isSet(object.bssid) ? bytesFromBase64(object.bssid) : new Uint8Array(),
      channel: isSet(object.channel) ? Number(object.channel) : 0,
    };
  },

  toJSON(message: CmdSetConfig): unknown {
    const obj: any = {};
    message.ssid !== undefined &&
      (obj.ssid = base64FromBytes(message.ssid !== undefined ? message.ssid : new Uint8Array()));
    message.passphrase !== undefined &&
      (obj.passphrase = base64FromBytes(message.passphrase !== undefined ? message.passphrase : new Uint8Array()));
    message.bssid !== undefined &&
      (obj.bssid = base64FromBytes(message.bssid !== undefined ? message.bssid : new Uint8Array()));
    message.channel !== undefined && (obj.channel = Math.round(message.channel));
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdSetConfig>, I>>(base?: I): CmdSetConfig {
    return CmdSetConfig.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdSetConfig>, I>>(object: I): CmdSetConfig {
    const message = createBaseCmdSetConfig();
    message.ssid = object.ssid ?? new Uint8Array();
    message.passphrase = object.passphrase ?? new Uint8Array();
    message.bssid = object.bssid ?? new Uint8Array();
    message.channel = object.channel ?? 0;
    return message;
  },
};

function createBaseRespSetConfig(): RespSetConfig {
  return { status: 0 };
}

export const RespSetConfig = {
  encode(message: RespSetConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespSetConfig {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespSetConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RespSetConfig {
    return { status: isSet(object.status) ? statusFromJSON(object.status) : 0 };
  },

  toJSON(message: RespSetConfig): unknown {
    const obj: any = {};
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    return obj;
  },

  create<I extends Exact<DeepPartial<RespSetConfig>, I>>(base?: I): RespSetConfig {
    return RespSetConfig.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespSetConfig>, I>>(object: I): RespSetConfig {
    const message = createBaseRespSetConfig();
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseCmdApplyConfig(): CmdApplyConfig {
  return {};
}

export const CmdApplyConfig = {
  encode(_: CmdApplyConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CmdApplyConfig {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCmdApplyConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): CmdApplyConfig {
    return {};
  },

  toJSON(_: CmdApplyConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CmdApplyConfig>, I>>(base?: I): CmdApplyConfig {
    return CmdApplyConfig.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CmdApplyConfig>, I>>(_: I): CmdApplyConfig {
    const message = createBaseCmdApplyConfig();
    return message;
  },
};

function createBaseRespApplyConfig(): RespApplyConfig {
  return { status: 0 };
}

export const RespApplyConfig = {
  encode(message: RespApplyConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RespApplyConfig {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRespApplyConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RespApplyConfig {
    return { status: isSet(object.status) ? statusFromJSON(object.status) : 0 };
  },

  toJSON(message: RespApplyConfig): unknown {
    const obj: any = {};
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    return obj;
  },

  create<I extends Exact<DeepPartial<RespApplyConfig>, I>>(base?: I): RespApplyConfig {
    return RespApplyConfig.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<RespApplyConfig>, I>>(object: I): RespApplyConfig {
    const message = createBaseRespApplyConfig();
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseWiFiConfigPayload(): WiFiConfigPayload {
  return {
    msg: 0,
    cmdGetStatus: undefined,
    respGetStatus: undefined,
    cmdSetConfig: undefined,
    respSetConfig: undefined,
    cmdApplyConfig: undefined,
    respApplyConfig: undefined,
  };
}

export const WiFiConfigPayload = {
  encode(message: WiFiConfigPayload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.msg !== 0) {
      writer.uint32(8).int32(message.msg);
    }
    if (message.cmdGetStatus !== undefined) {
      CmdGetStatus.encode(message.cmdGetStatus, writer.uint32(82).fork()).ldelim();
    }
    if (message.respGetStatus !== undefined) {
      RespGetStatus.encode(message.respGetStatus, writer.uint32(90).fork()).ldelim();
    }
    if (message.cmdSetConfig !== undefined) {
      CmdSetConfig.encode(message.cmdSetConfig, writer.uint32(98).fork()).ldelim();
    }
    if (message.respSetConfig !== undefined) {
      RespSetConfig.encode(message.respSetConfig, writer.uint32(106).fork()).ldelim();
    }
    if (message.cmdApplyConfig !== undefined) {
      CmdApplyConfig.encode(message.cmdApplyConfig, writer.uint32(114).fork()).ldelim();
    }
    if (message.respApplyConfig !== undefined) {
      RespApplyConfig.encode(message.respApplyConfig, writer.uint32(122).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiFiConfigPayload {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiFiConfigPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.msg = reader.int32() as any;
          break;
        case 10:
          message.cmdGetStatus = CmdGetStatus.decode(reader, reader.uint32());
          break;
        case 11:
          message.respGetStatus = RespGetStatus.decode(reader, reader.uint32());
          break;
        case 12:
          message.cmdSetConfig = CmdSetConfig.decode(reader, reader.uint32());
          break;
        case 13:
          message.respSetConfig = RespSetConfig.decode(reader, reader.uint32());
          break;
        case 14:
          message.cmdApplyConfig = CmdApplyConfig.decode(reader, reader.uint32());
          break;
        case 15:
          message.respApplyConfig = RespApplyConfig.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WiFiConfigPayload {
    return {
      msg: isSet(object.msg) ? wiFiConfigMsgTypeFromJSON(object.msg) : 0,
      cmdGetStatus: isSet(object.cmdGetStatus) ? CmdGetStatus.fromJSON(object.cmdGetStatus) : undefined,
      respGetStatus: isSet(object.respGetStatus) ? RespGetStatus.fromJSON(object.respGetStatus) : undefined,
      cmdSetConfig: isSet(object.cmdSetConfig) ? CmdSetConfig.fromJSON(object.cmdSetConfig) : undefined,
      respSetConfig: isSet(object.respSetConfig) ? RespSetConfig.fromJSON(object.respSetConfig) : undefined,
      cmdApplyConfig: isSet(object.cmdApplyConfig) ? CmdApplyConfig.fromJSON(object.cmdApplyConfig) : undefined,
      respApplyConfig: isSet(object.respApplyConfig) ? RespApplyConfig.fromJSON(object.respApplyConfig) : undefined,
    };
  },

  toJSON(message: WiFiConfigPayload): unknown {
    const obj: any = {};
    message.msg !== undefined && (obj.msg = wiFiConfigMsgTypeToJSON(message.msg));
    message.cmdGetStatus !== undefined &&
      (obj.cmdGetStatus = message.cmdGetStatus ? CmdGetStatus.toJSON(message.cmdGetStatus) : undefined);
    message.respGetStatus !== undefined &&
      (obj.respGetStatus = message.respGetStatus ? RespGetStatus.toJSON(message.respGetStatus) : undefined);
    message.cmdSetConfig !== undefined &&
      (obj.cmdSetConfig = message.cmdSetConfig ? CmdSetConfig.toJSON(message.cmdSetConfig) : undefined);
    message.respSetConfig !== undefined &&
      (obj.respSetConfig = message.respSetConfig ? RespSetConfig.toJSON(message.respSetConfig) : undefined);
    message.cmdApplyConfig !== undefined &&
      (obj.cmdApplyConfig = message.cmdApplyConfig ? CmdApplyConfig.toJSON(message.cmdApplyConfig) : undefined);
    message.respApplyConfig !== undefined &&
      (obj.respApplyConfig = message.respApplyConfig ? RespApplyConfig.toJSON(message.respApplyConfig) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<WiFiConfigPayload>, I>>(base?: I): WiFiConfigPayload {
    return WiFiConfigPayload.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<WiFiConfigPayload>, I>>(object: I): WiFiConfigPayload {
    const message = createBaseWiFiConfigPayload();
    message.msg = object.msg ?? 0;
    message.cmdGetStatus = (object.cmdGetStatus !== undefined && object.cmdGetStatus !== null)
      ? CmdGetStatus.fromPartial(object.cmdGetStatus)
      : undefined;
    message.respGetStatus = (object.respGetStatus !== undefined && object.respGetStatus !== null)
      ? RespGetStatus.fromPartial(object.respGetStatus)
      : undefined;
    message.cmdSetConfig = (object.cmdSetConfig !== undefined && object.cmdSetConfig !== null)
      ? CmdSetConfig.fromPartial(object.cmdSetConfig)
      : undefined;
    message.respSetConfig = (object.respSetConfig !== undefined && object.respSetConfig !== null)
      ? RespSetConfig.fromPartial(object.respSetConfig)
      : undefined;
    message.cmdApplyConfig = (object.cmdApplyConfig !== undefined && object.cmdApplyConfig !== null)
      ? CmdApplyConfig.fromPartial(object.cmdApplyConfig)
      : undefined;
    message.respApplyConfig = (object.respApplyConfig !== undefined && object.respApplyConfig !== null)
      ? RespApplyConfig.fromPartial(object.respApplyConfig)
      : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

function bytesFromBase64(b64: string): Uint8Array {
  if (tsProtoGlobalThis.Buffer) {
    return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = tsProtoGlobalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if (tsProtoGlobalThis.Buffer) {
    return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(String.fromCharCode(byte));
    });
    return tsProtoGlobalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
